import { paginationSize } from '../../../constants/constants';
import { SET_DEFAULT_CONFIGURATIONS } from '../../actions';
import {
    FETCH_VERIFIED_START,
    FETCH_VERIFIED_SUCCESS,
    FETCH_VERIFIED_ERROR,
    SET_VERIFIED_FILTER,
    UNDO_REPORT_FROM_HOLD_QUEUE_SUCCESS,
    SET_VERIFIED_PAGINATION,
    VIEW_VERIFIED_VISIT_LOADING_START,
    VIEW_VERIFIED_VISIT_LOADING_END,
    RESET_VERIFIED_FILTER,
    SET_VERIFIED_ALL_CASES_FILTER,
} from '../../actions/mis/verifiedAction';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    verified: [],
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
        myCasesOnly: true,
        startDate: null,
        endDate: null,
    },
    sortConditions: [{ sortBy: "verificationDate", dataType: "DATE", sortType: "desc" }],
    skippedVisits: [],
};

const verifiedReducer = (state = INIT_STATE, action) => {
    let newState;
    let index;
    let searchFilter;
    switch (action.type) {
        case SET_DEFAULT_CONFIGURATIONS: {
            searchFilter = {
                ...INIT_STATE.searchFilter,
                risId: action.configurations.default_ris_id || 1,
                mipIds: action.configurations.default_mip_id ? [action.configurations.default_mip_id] : [],
                myCasesOnly: action.configurations.show_my_cases_only,
            };
            return { ...state, searchFilter };
        }
        case FETCH_VERIFIED_START:
        case VIEW_VERIFIED_VISIT_LOADING_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_VERIFIED_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, verified: action.verified };
        }
        case FETCH_VERIFIED_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        case SET_VERIFIED_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }
        case UNDO_REPORT_FROM_HOLD_QUEUE_SUCCESS: {
            let newVerified = [...state.verified];
            index = newVerified.findIndex(report => report.reportId === action.reportId);
            if (index > -1) {
                newVerified.splice(index, 1);
            }
            return { ...state, error: '', message: '', loading: false, verified: newVerified }
        }
        case SET_VERIFIED_FILTER: {
            newState = { ...state };
            newState.searchFilter = { ...action.payload.searchFilter }
            newState.sortConditions = action.payload.sortConditions.length > 0 ? [...action.payload.sortConditions] : []
            newState.skippedVisits = action.payload.skippedVisits.length > 0 ? [...action.payload.skippedVisits] : []
            return {
                ...newState
            }
        }

        case VIEW_VERIFIED_VISIT_LOADING_END: {
            return { ...state, loading: false };
        }

        case RESET_VERIFIED_FILTER: {
            newState = { ...state };
            newState.searchFilter.searchText = null;
            newState.searchFilter.startDate = null;
            newState.searchFilter.endDate = null;
            return { ...newState };
        }

        case SET_VERIFIED_ALL_CASES_FILTER: {
            newState = { ...state };
            newState.searchFilter.myCasesOnly = action.payload.myCasesOnly;
            return { ...newState };
        }
        default:
            return state;
    }
}

export default verifiedReducer;
